import React, {
  useEffect,
  useState,
} from "react";
import {
  useLocation,
  useParams,
} from "react-router-dom";
import {
  tryFetch,
  IResponse,
} from "../../../helpers/FetchAPI";
import GetTicketPage from "./index";
import GetTicketRequired from "./getTicketRequired";

const toBoolean = (
  value: unknown
): boolean => {
  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "number") {
    return value === 1;
  }

  if (typeof value === "string") {
    const normalizedValue = value
      .trim()
      .toLowerCase();

    return (
      normalizedValue === "true" ||
      normalizedValue === "1"
    );
  }

  return false;
};

const GetTicketWrapper: React.FC =
  () => {
    const { slug } = useParams();
    const location = useLocation();

    const eventId =
      location.state?.eventId;

    const [
      eventData,
      setEventData,
    ] = useState<any>(null);

    useEffect(() => {
      let isMounted = true;

      const load = async () => {
        if (!eventId) {
          console.error(
            "Event ID not found."
          );

          if (isMounted) {
            setEventData(null);
          }

          return;
        }

        try {
          const res: IResponse =
            await tryFetch({
              url: `/events/${eventId}?timestamp=${Date.now()}`,
              method: "GET",
            });

          if (!isMounted) {
            return;
          }

          if (
            res.is_success &&
            res.data
          ) {
            setEventData(res.data);
          } else {
            console.error(
              "Failed to fetch event:",
              res.error
            );

            setEventData(null);
          }
        } catch (error) {
          console.error(
            "Failed to load event:",
            error
          );

          if (isMounted) {
            setEventData(null);
          }
        }
      };

      load();

      return () => {
        isMounted = false;
      };
    }, [eventId, slug]);

    if (!eventData) {
      return <div>Loading...</div>;
    }

    const requiresCustomerData =
      toBoolean(
        eventData.require_customer_data
      );

    if (requiresCustomerData) {
      return <GetTicketRequired />;
    }

    return <GetTicketPage />;
  };

export default GetTicketWrapper;